import VivaEngageLogo from '@ms/yammer-assets/dist/images/VivaEngageLogo.svg';
import { useTranslations } from '@ms/yammer-i18n-react';
import ErrorStrings from '@ms/yammer-strings/dist/Error';
import Block from '@ms/yammer-web-core-ui/dist/components/Block';
import Clickable from '@ms/yammer-web-core-ui/dist/components/Clickable';
import FakeLink from '@ms/yammer-web-core-ui/dist/components/FakeLink';
import Image from '@ms/yammer-web-core-ui/dist/components/Image';
import Paragraph from '@ms/yammer-web-core-ui/dist/components/Paragraph';
import VerticalAlign from '@ms/yammer-web-core-ui/dist/components/VerticalAlign';
import type { FC } from 'react';
import React from 'react';

import { useClassNames } from './FailedToLoad.styles';

const reload = () => window.location.reload();

export interface FailedToLoadProps {
  readonly error?: string;
  readonly title?: string;
}

export const FailedToLoad: FC<FailedToLoadProps> = ({ error, title }) => {
  const t = useTranslations(ErrorStrings);
  const classNames = useClassNames();

  const fallbackCallToAction = (
    <>
      Please <FakeLink key="failed-to-load-link">try again</FakeLink> in a few minutes.
    </>
  );
  const preferredCallToAction = t.failedToLoadCallToAction({
    link: (text) => <FakeLink key="failed-to-load-link">{text}</FakeLink>,
  });
  const callToAction = preferredCallToAction || fallbackCallToAction;

  const fallbackMessage = `This page isn't loading right now.`;
  const message = t.failedToLoadMessage() || fallbackMessage;
  const heading = title || message;

  const content = error ? (
    <Block paddingTop={3}>{error}</Block>
  ) : (
    <Clickable onClick={reload} display="block" unstyled={true}>
      <Paragraph>{callToAction}</Paragraph>
    </Clickable>
  );

  return (
    <VerticalAlign horizontalAlign="center" height="100vh">
      <div className={classNames.yammerLogo}>
        <Image source={VivaEngageLogo} description="" shouldFadeIn={false} />
      </div>
      <Block textPreset="title3">{heading}</Block>
      {content}
    </VerticalAlign>
  );
};
